import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title, 
  description, 
  canonicalUrl, 
  noIndex = false,
  imageUrl = '/og-image.jpg',
  keywords = [],
  author = 'AapkaPG'
}) => {
  const fullTitle = title || 'AapkaPG - Find Verified PG Accommodation';
  const fullDescription = description || 'Search, compare & book verified PGs across India. Zero brokerage, real photos, instant booking.';
  const fullCanonical = canonicalUrl?.startsWith('http') 
    ? canonicalUrl 
    : `https://aapkapg.com${canonicalUrl || ''}`;
  
  // Debug log to confirm SEO is being called
  console.log('🔍 SEO Component Rendering:', { 
    title: fullTitle, 
    description: fullDescription,
    canonical: fullCanonical
  });
  
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="author" content={author} />
      {keywords.length > 0 && (
        <meta name="keywords" content={keywords.join(', ')} />
      )}
      <link rel="canonical" href={fullCanonical} />
      
      {noIndex && <meta name="robots" content="noindex, nofollow" />}
      {!noIndex && <meta name="robots" content="index, follow" />}
      
      {/* Open Graph */}
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="AapkaPG" />
      {imageUrl && <meta property="og:image" content={imageUrl} />}
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      
      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
      {imageUrl && <meta name="twitter:image" content={imageUrl} />}
    </Helmet>
  );
};

export default SEO;